import { useState } from 'react';

import { Button } from '@/shared/components/ui/button';
import { Card, CardContent } from '@/shared/components/ui/card';

import { Icon, IconKey } from './icon';

const ERROR_ILLUSTRATIONS = [
  'amico-404.svg',
  'cuate-404.svg',
  'pana-404.svg',
  'rafiki-404.svg',
];


interface ErrorCardProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorCard({ title = 'Something went wrong', message, onRetry }: ErrorCardProps) {
  const [illustration] = useState(
    () => ERROR_ILLUSTRATIONS[Math.floor(Math.random() * ERROR_ILLUSTRATIONS.length)]
  );

  return (
    <Card className="border-destructive/50 bg-linear-to-b from-destructive/50 via-card/0 to-card/50 w-md shadow-lg">
      <CardContent className="flex flex-col items-center justify-center py-8 text-center">
        <img src={illustration} alt="Error" className="size-64 mb-4 object-contain" />
        <span className="font-semibold text-lg mb-2">{title}</span>
        <p className="text-muted-foreground mb-4 max-w-md">{message}</p>
        {onRetry && (
          <Button variant="outline" onClick={onRetry}>
            <Icon icon={IconKey.Refresh} size={14} />
            Retry
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

